module.exports = __webpack_public_path__ + "img/arrow-right-link.26a2556d.svg";